import type { GameMeta } from '@gmp/game-sdk';

export const theAlibiMeta = {
  id: 'the-alibi',
  name: 'The Alibi',
  tagline: 'Everyone has an alibi. One of them is a lie. The evidence knows which.',
  description:
    'Each round is a fictional incident with a fixed timeline. You play one of the characters and get your private facts. One player is the liar, handed a cover story that the evidence quietly contradicts. Everyone files an alibi, then evidence unlocks in two drops. Accuse the liar privately and point to the exact clue that breaks their story. The liar scores if the alibi holds up. Play in one sitting or over a few days.',
  minPlayers: 3,
  maxPlayers: 10,
  estimatedMinutes: [15, 30],
  usesMedia: false,
  modes: [{ id: 'case', name: 'Case files', description: 'A new authored case each round, and a new liar.' }],
  theme: { primary: '#d9b45a', secondary: '#c2413b', background: '#141821', ink: '#f2ead8' },
  readiness: 'beta',
  genre: 'Deduction and bluffing',
  controls: 'tap',
  category: 'async',
  asyncInfo: {
    turnSeconds: [30, 120],
    match: { quick: '15–30 min', daily: '3–12 days' },
    difficulty: 'medium',
    tags: ['deduction', 'bluffing', 'social'],
  },
  instructions: [
    { icon: 'EyeOff', title: 'Get your character', body: 'Each round is a new incident. You play one of the characters and see your private facts: where you really were. One player is secretly the liar and gets a cover story instead.' },
    { icon: 'BookOpen', title: 'File your alibi', body: 'Pick how you put each part of your alibi (where you were at each time) and add a line of your own if you like. The liar must tell their cover story.' },
    { icon: 'Vote', title: 'Read the evidence', body: 'Evidence unlocks in two drops: camera stills, logs, receipts, witness notes. Exactly one alibi line clashes with exactly one piece of evidence.' },
    { icon: 'Trophy', title: 'Accuse', body: 'Privately name the liar (+3) and the clue that breaks their story (+2). The liar scores +4 if fewer than half the accusers catch them. Steps move on when everyone is in or time runs out.' },
  ],
} satisfies GameMeta;
